"use client";

import { nativeSupportSnapshot } from "@/lib/webmcp/native-support";

let runtimePromise: Promise<NonNullable<
  Document["modelContext"]
> | null> | null = null;

export function hasNativeWebMCPSupport(): boolean {
  return nativeSupportSnapshot;
}

export function ensureWebMCP(): Promise<NonNullable<
  Document["modelContext"]
> | null> {
  runtimePromise ??= (async () => {
    try {
      await import("@mcp-b/global");
      return document.modelContext ?? navigator.modelContext ?? null;
    } catch {
      return null;
    }
  })();

  return runtimePromise;
}
